import { ReactNode } from 'react';

import { FormControlLabel } from '@mui/material';

import { Radio, Typography, Stack, tokens } from '@cast/design-system';

import type { TypographyProps } from '@cast/design-system';

type RadioOptionCardProps = {
  value: string;
  isSelected: boolean;
  icon: ReactNode;
  label: string;
  description?: string;
  testId?: string;
  typographyVariant?: TypographyProps['variant'];
  disabled?: boolean;
};

export const RadioOptionCard = ({
  value,
  isSelected,
  icon,
  label,
  description,
  testId,
  typographyVariant,
  disabled = false,
}: RadioOptionCardProps) => (
  <FormControlLabel
    disableTypography
    sx={{
      m: 0,
      flex: 1,
      padding: 12,
      borderRadius: '4px',
      border: '1px solid',
      borderColor: disabled
        ? tokens.theme.disabled.border
        : isSelected
        ? tokens.theme.border.selection.primary
        : tokens.theme.border.structural.neutral,
      backgroundColor: tokens.theme.bg.structural.surface,
      color: disabled
        ? tokens.theme.disabled.fg
        : tokens.theme.fg.structural.primary,
      alignItems: 'center',
      '&:hover': {
        backgroundColor: tokens.theme.bg.structural.surface,
        borderColor: disabled
          ? tokens.theme.disabled.border
          : isSelected
          ? tokens.theme.border.selection.primary
          : tokens.theme.border.action.neutralHover,
      },
    }}
    control={
      <Radio testId={testId} size="small" value={value} disabled={disabled} />
    }
    label={
      <Stack direction="row" ml={8} gap={8} alignItems="center">
        {icon}
        <Stack>
          <Typography
            variant={typographyVariant ?? 'P10B'}
            sx={{
              color: disabled
                ? tokens.theme.disabled.fg
                : tokens.theme.fg.structural.primary,
            }}
          >
            {label}
          </Typography>
          {description && (
            <Typography
              variant="P10R"
              sx={{
                color: disabled
                  ? tokens.theme.disabled.fg
                  : tokens.theme.fg.structural.secondary,
              }}
            >
              {description}
            </Typography>
          )}
        </Stack>
      </Stack>
    }
  />
);
